import type { SelectHTMLAttributes } from 'react';
import { cn } from './utils';

type SelectProps = SelectHTMLAttributes<HTMLSelectElement> & { className?: string };

/**
 * Native `<select>` styled with the `.select` primitive (app-level
 * `globals.css` — see plans/filter-standardization-spec.md §5). The missing
 * counterpart to `Field`'s `TextInput`. Pair with `Field` for label/hint/
 * error chrome; do not pass an `aria-label` in place of a `Field` label.
 *
 * Deliberately a plain native select, not a custom listbox — every filter
 * option list on the screens that need this is flat and short, and native
 * selects are fully keyboard/AT-operable for free.
 */
export function Select({ className, ...props }: SelectProps) {
  return <select className={cn('select', className)} {...props} />;
}
